import { PatstoreWebpage } from "@types";
import { useMemo } from "react";
import useGetWebpage from "./patstore/useGetWebpage";

const useFindWebpage = ({ path }: { path?: string }) => {
  const { webpages } = useGetWebpage();

  const allWebpage = webpages || [];

  const webpage = useMemo((): PatstoreWebpage | undefined => {
    if (!path) {
      return undefined;
    }
    const content = allWebpage.find((page: PatstoreWebpage) =>
      page?.path?.includes(path),
    );

    if (!content) {
      return undefined;
    }

    return content;
  }, [path]);

  return webpage;
};

export default useFindWebpage;
